import { Banner, Page } from '@/components';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
import { Box, Flex, Heading } from '@blockanalitica/ui';

export default function ExpensesPage() {
  return (
    <Page title="Expenses">
      <Banner>
        <Box paddingTop="xs" paddingBottom="m" maxWidth="85%">
          <Heading size="2">About the Sky Protocol Expenses</Heading>
          <br />
          Track Sky Protocol expenses. This page offers a granular breakdown of
          vest and spell expenses.
        </Box>
      </Banner>
      <HistoricTabs />
      <Flex flexBasis="100%" gap={['m', 's']} flexDirection="column">
        <Heading size="3">Transfers</Heading>
        <EventsTable />
      </Flex>
    </Page>
  );
}
